module.exports = __webpack_public_path__ + "img/email.f09ff52c.svg";